import { useMemo } from "react";
import QuickInsightCard from "./QuickInsightCard";
import { ApiQuickInsightResult } from "@incendium/api";
import { shuffleArray } from "Helpers/arrays";
import CarouselCard from "Components/UI/CarouselCard";

interface IQuickInsightCarouselProps {
  insights: ApiQuickInsightResult[];
  loading?: boolean;
}

function QuickInsightCarousel({
  insights,
  loading,
}: IQuickInsightCarouselProps) {
  const shuffledInsights = useMemo(() => {
    return shuffleArray(insights);
  }, [insights]);
  return (
    <CarouselCard
      title="Quick Insights"
      inview={4}
      emptyMessage={"No insights available"}
      items={shuffledInsights.map((insight) => (
        <QuickInsightCard insight={insight} width={"100%"} />
      ))}
      loading={loading}
    />
  );
}

export default QuickInsightCarousel;
